import PageData from '@/types/page-data';
import type {ColumnType as TableColumnType} from 'antd/lib/table';
import {Pagination, Table} from 'antd';
import React from 'react';
import './pagination-table.scss';
import PageParam from '@/types/page-param';
import {ExpandableConfig} from 'antd/lib/table/interface';

export type ColumnType<RecordType> = TableColumnType<RecordType>;

interface PaginationTableProps<RecordType> {
    columns: ColumnType<RecordType>[];
    data?: PageData<RecordType>;
    setPageParam?: (page: PageParam) => void;
    expandable?: ExpandableConfig<RecordType>;
    showPagination?: boolean;
}

const PaginationTable: React.FC<PaginationTableProps<any>> = (props) => {
    const {columns, data, setPageParam, expandable, showPagination = true} = props;

    return (
        <div>
            <Table columns={columns} dataSource={data?.content || []} rowKey={'id'} pagination={false} expandable={expandable} />
            {showPagination && data && (
                <div className="pagination">
                    <Pagination
                        current={data.page + 1}
                        pageSize={data.size}
                        total={data.total}
                        hideOnSinglePage
                        showSizeChanger
                        onChange={(page, pageSize) => {
                            setPageParam?.({page: page - 1, size: pageSize});
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default PaginationTable;
